const StartPage = () => {
    return (
        <div className="grow border-x-8 border-custom-bg-gray overflow-auto">
            <div className="max-w-3xl px-6 mx-auto flex flex-col left justify-center p-12 gap-y-4">
                <h1 className="text-darkpink dark-pink font-chat-intro-title text-chat-intro-title">
                    Willkommen <br /> im Dialog
                </h1>
                <div className="font-chat-intro text-chat-intro mb-4 pt-8">
                    NextGeneration:AI ist der KI-Chatbot der Carl Remigius Fresenius Education Group und steht allen
                    Mitarbeiter:innen, Lehrenden, Studierenden und Schüler:innen der Bildungsgruppe zur Verfügung.
                </div>
                <div className="font-chat-intro text-chat-intro mb-4 pt-4">
                    Der Login findet über die Lernmanagement-Systeme der einzelnen Bildungsreinrichtungen (Ilias und
                    studynet) statt.
                </div>
                <div className="font-chat-intro text-chat-intro mb-4 pt-4">
                    Mitarbeiter:innen ohne einen Zugang zu Ilias oder studynet nutzen den App-Launcher oben rechts neben
                    dem Suchfeld in 18vier8.
                </div>
            </div>
        </div>
    );
};

export default StartPage;
